<template>
  <section class="w-100 blocksLibrary" :class="{ inactiveFlow: inactiveFlow }">
    <CCol sm="12" style="z-index: 2" class="p-0">
      <header class="bg-gray-200 text-secondary sidebar__header pt-4 pb-2 px-3 text-center d-flex justify-content-between align-items-center mb-3">
        <h5 class="font-weight-normal">
          {{ $t('sidebar.blocksLibrary.campaign.text.settings-custom') }}
        </h5>
      </header>

      <div v-if="mainCampaign.values.length && activeBlock.indexChannel != null">
        <CCard class="collapsibleCard shadow-none w-100">
          <CButton
            @click="handlerCollapse('audience')"
            tag="button"
            variant="ghost"
            block
            class="text-left shadow-none card-header collapsibleCard__button py-3"
          >
            <h6
              class="d-flex justify-content-between text-uppercase align-items-center m-0 font-weight-normal text-gray-600"
              :class="{ 'text-gray-base': collapse.audience }"
            >
              {{ $t('sidebar.blocksLibrary.campaign.component.title.target') }}
              <CIcon name="arrow" :height="13" :class="{ icon__rotateRigth: !collapse.audience }" viewBox="0 0 32 32" />
            </h6>
          </CButton>
          <CCollapse :show="collapse.audience">
            <CCardBody class="m-1 p-3">
              <Audience :channel="activeBlock" :audience="mainCampaign.values[activeBlock.indexChannel].audience" />
            </CCardBody>
          </CCollapse>
        </CCard>

        <CCard class="collapsibleCard shadow-none w-100">
          <CButton
            @click="handlerCollapse('content')"
            tag="button"
            variant="ghost"
            block
            class="text-left shadow-none card-header collapsibleCard__button py-3"
          >
            <h6
              class="d-flex justify-content-between text-uppercase align-items-center m-0 font-weight-normal text-gray-600"
              :class="{ 'text-gray-base': collapse.content }"
            >
              {{ $t('sidebar.blocksLibrary.campaign.component.title.content') }}
              <CIcon name="arrow" :height="13" :class="{ icon__rotateRigth: !collapse.content }" viewBox="0 0 32 32" />
            </h6>
          </CButton>
          <CCollapse :show="collapse.content">
            <CCardBody class="m-1 p-3">
              <SmsContent
                v-if="activeBlock.type === 'SMS'"
                :indice="activeBlock.indexChannel"
                :content="mainCampaign.values[activeBlock.indexChannel].content"
              />
              <EmailContent v-else :indice="activeBlock.indexChannel" :content="mainCampaign.values[activeBlock.indexChannel].content" />
            </CCardBody>
          </CCollapse>
        </CCard>

        <CCard class="collapsibleCard shadow-none w-100">
          <CButton
            @click="handlerCollapse('time')"
            tag="button"
            variant="ghost"
            block
            class="text-left shadow-none card-header collapsibleCard__button py-3"
          >
            <h6
              class="d-flex justify-content-between text-uppercase align-items-center m-0 font-weight-normal text-gray-600"
              :class="{ 'text-gray-base': collapse.time }"
            >
              {{ $t('sidebar.blocksLibrary.campaign.component.title.time') }}
              <CIcon name="arrow" :height="13" :class="{ icon__rotateRigth: !collapse.time }" viewBox="0 0 32 32" />
            </h6>
          </CButton>
          <CCollapse :show="collapse.time">
            <CCardBody class="m-1 p-3">
              <Time :time="mainCampaign.values[activeBlock.indexChannel].time" :indice="activeBlock.indexChannel" />
            </CCardBody>
          </CCollapse>
        </CCard>
      </div>
      <div v-else>
        <h4 class="text-center h-100 p-5 text-gray-600">
          {{ $t('sidebar.blocksLibrary.campaign.text.start-your-campaign') }}
        </h4>
      </div>
    </CCol>
  </section>
</template>

<script>
import Audience from '@/views/campaign/components/BlocksLibrary/Audience'
import Time from '@/views/campaign/components/BlocksLibrary/Time'
import SmsContent from '@/views/campaign/components/BlocksLibrary/SmsContent'
import EmailContent from '@/views/campaign/components/BlocksLibrary/EmailContent'
export default {
  name: 'BlocksLibrary',
  components: {
    Audience,
    EmailContent,
    SmsContent,
    Time,
  },
  props: {
    minimizeBar: {
      type: Boolean,
    },
  },
  data() {
    return {
      componentKey: null,
      messagesChannels: [],
      type: '',
      channels: [],
    }
  },

  computed: {
    mainCampaign() {
      const campaign = JSON.parse(JSON.stringify(this.$store.state.campaign.mainCampaign))
      this.openBlockChannelsIfModelsCustom(campaign.type)
      return campaign
    },

    activeBlock() {
      return this.$store.state.campaign.activeBlock
    },

    inactiveFlow() {
      return this.$store.state.campaign.inactiveFlow
    },

    collapse() {
      return this.$store.state.campaign.collapse
    },
  },

  methods: {
    initialCollapse() {
      this.$store.dispatch('campaign/collapse', 'channels')
    },
    forceRerender() {
      return Math.floor(Math.random() * 1000 + 1)
    },
    openBlockChannelsIfModelsCustom(type) {
      if (type == 'CUSTOM') {
        this.collapse.channels = true
      }
    },

    handlerCollapse(block) {
      this.$store.dispatch('campaign/setCurrentChannel', {
        blockLibrary: true,
        indexChannel: this.activeBlock.indexChannel,
        cardName: block,
        type: this.activeBlock.type,
        collapse: block,
      })
    },
  },

  watch: {
    minimizeBar: {
      handler: function (state) {
        if (state) {
          this.collapse = {
            channels: false,
            audience: false,
            time: false,
            content: false,
          }
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
.cardChannel {
  &__checkRadio {
    &--active {
      + .cardChannel__child {
        border-color: var(--primary);
        background: transparent;
        .c-icon {
          color: var(--primary);
        }
        span {
          color: var(--gray-base);
        }
      }
    }
  }

  &__child {
    border: 1px solid #f1f5fb;
    border-radius: 3px;
    cursor: pointer;

    &:hover {
      * {
        cursor: pointer;
      }

      border-color: var(--primary);
      background: transparent;
      .c-icon {
        color: var(--primary);
      }
      span {
        color: var(--gray-base);
      }
    }
  }

  &:nth-child(n + 3) &__child {
    margin-top: 1.3rem;
  }
}
</style>

<style lang="scss" scoped>
.collapsibleCard {
  margin: 0;
}

.form-searchBox {
  position: relative;
}

.form-searchBox {
  background-color: #f1f5fb;
  border-bottom: 1px solid #f1f5fb;
}

.tabs {
  &__item {
    flex: 1 0;
    text-align: center;
    font-size: 20px;

    .nav-link {
      border-radius: 0;
    }
  }
}
</style>
